import "../styles/Navbar.css"

import { Link, NavLink, useLocation } from "react-router-dom"
import React, { useEffect } from "react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Helmet } from "react-helmet-async"
import { faAngleDown } from "@fortawesome/free-solid-svg-icons"
import logo from "../img/logo/logo_iris.png"

const Navbar = () => {
  const location = useLocation()

  useEffect(() => {
    window.addEventListener("scroll", resizeHeaderOnScroll)
  })
  const resizeHeaderOnScroll = () => {
    const distanceY = window.pageYOffset || document.documentElement.scrollTop,
      shrinkOn = 200,
      navbar = document.querySelector(".navbar"),
      navbarToggler = document.querySelector(".navbar-toggler-icon"),
      logo = document.querySelector(".logo"),
      dropdownItem = document.querySelector(".dropdown-item")
    if (distanceY > shrinkOn) {
      navbar.classList.add("shrink")
      navbarToggler.classList.add("toggler-shrink")
      navbarToggler.classList.remove("resize-toggler-shrink")
      logo.classList.remove("resize")
      dropdownItem.classList.add("item-shrink")
    } else {
      navbar.classList.remove("shrink")
      navbarToggler.classList.add("resize-toggler-shrink")
      logo.classList.add("resize")
      dropdownItem.classList.remove("item-shrink")
    }
  }
  const handleCollapse = () => {
    var nav = document.getElementById("navbarNav")
    var btn = document.getElementById("navbarBtn")
    nav.classList.remove("show")
    btn.classList.add("collapsed")

    const dropdownMenus = document.querySelectorAll(".dropdown-menu.show")
    dropdownMenus.forEach((menu) => {
      menu.classList.remove("show")
    })

    const dropdownToggles = document.querySelectorAll(
      '.dropdown-toggle[aria-expanded="true"]'
    )
    dropdownToggles.forEach((toggle) => {
      toggle.setAttribute("aria-expanded", "false")
    })
  }

  return (
    <div className="Navbar">
      <Helmet>
        <meta
          name="description"
          content="Iris Ambiente Sas - Strategie per l'Ambiente - Navigation Bar"
        />
      </Helmet>
      <nav className="Navbar navbar fixed-top navbar-expand-lg navbar-light bg-white">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src={logo} className="logo" alt="Iris logo" />
          </Link>
          <button
            className="navbar-toggler not-resize justify-content-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            id="navbarBtn"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div
            className="collapse navbar-collapse justify-content-center"
            id="navbarNav"
          >
            <ul className="navbar-nav">
              <li className="nav-item active">
                <NavLink
                  className={({ isActive }) =>
                    isActive ? "nav-link nav-link-active" : "nav-link"
                  }
                  to="/"
                  onClick={handleCollapse}
                >
                  Home<span className="sr-only">(current)</span>
                </NavLink>
              </li>
              <li className="nav-item dropdown">
                <a
                  className={`${
                    location.pathname.startsWith("/chi-siamo") &&
                    "nav-link-active"
                  } nav-link dropdown-toggle`}
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Chi Siamo
                  <FontAwesomeIcon icon={faAngleDown} className="arrow" />
                </a>
                <div className="dropdown-menu">
                  <Link
                    className="text-lg-left dropdown-item item-shrink"
                    to="/chi-siamo/la-societa"
                    onClick={handleCollapse}
                  >
                    La società
                  </Link>
                  <Link
                    className="text-lg-left dropdown-item item-shrink"
                    to="/chi-siamo/il-team"
                    onClick={handleCollapse}
                  >
                    Il team
                  </Link>
                  <Link
                    className="text-lg-left dropdown-item item-shrink"
                    to="/chi-siamo/partner"
                    onClick={handleCollapse}
                  >
                    Partner
                  </Link>
                </div>
              </li>
              <li className="nav-item dropdown">
                <a
                  className={`${
                    location.pathname.startsWith("/servizi") &&
                    "nav-link-active"
                  } nav-link dropdown-toggle`}
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Servizi
                  <FontAwesomeIcon icon={faAngleDown} className="arrow" />
                </a>
                <div className="dropdown-menu">
                  <Link
                    className="text-lg-left dropdown-item item-shrink"
                    to="/servizi/progetti"
                    onClick={handleCollapse}
                  >
                    Progetti
                  </Link>
                  <Link
                    className="text-lg-left dropdown-item item-shrink"
                    to="/servizi/studi"
                    onClick={handleCollapse}
                  >
                    Studi
                  </Link>
                  <Link
                    className="text-lg-left dropdown-item item-shrink"
                    to="/servizi/rilievi-geo-drone"
                    onClick={handleCollapse}
                  >
                    Rilievi geo-drone
                  </Link>
                  <Link
                    className="text-lg-left dropdown-item item-shrink"
                    to="/servizi/rilievi-idro-ambientali"
                    onClick={handleCollapse}
                  >
                    Rilievi idro-ambientali
                  </Link>
                  <Link
                    className="text-lg-left dropdown-item item-shrink"
                    to="/servizi/formazione"
                    onClick={handleCollapse}
                  >
                    Formazione
                  </Link>
                </div>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/esperienze"
                  className={({ isActive }) =>
                    isActive
                      ? "nav-link nav-link-active mb-2 mb-md-0"
                      : "nav-link mb-2 mb-md-0"
                  }
                  onClick={handleCollapse}
                >
                  Esperienze
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/contatti"
                  className={({ isActive }) =>
                    isActive
                      ? "nav-link nav-link-active mb-2 mb-md-0"
                      : "nav-link mb-2 mb-md-0"
                  }
                  onClick={handleCollapse}
                >
                  Contatti
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Navbar
